import Input, { info, style, validity } from "element/input";
import connected from "standard/connected";
import define from "standard/define";
import __ from "standard/dunder";
import * as f from "standard/f";
import joinCut from "standard/joinCut";
import on from "standard/on";
import onInvalid from "standard/onInvalid";
import paint from "standard/paint";
import repaint from "standard/repaint";
import trait from "standard/trait";

@define("m-password")
class Password extends Input {
  #supportText = "";
  #validity = validity.VALID;
  #value = "";

  @connected
  @paint
  [trait.template]() {
    return `
      <div class='${style.input__container}'>
        <label class='${style.input__label}' ${this.#validity} for='password'>Senha *</label>
        <input class='${style.input}' ${
          this.#validity
        } id='password' name='password' type='password' value='${this.#value}' autocomplete='off' required />
        <span class='${style.input__supporting}' ${this.#validity}>
          ${info()}
          ${this.#supportText}
        </span>
      </div>
    `;
  }

  @on.change("input")
  @joinCut(trait.check)
  [trait.onChange](event) {
    this.#value = event.target.value;
    return this;
  }

  @onInvalid
  @repaint
  [trait.check]() {
    if (f.isEmpty(this)) {
      this.#validity = validity.INVALID;
      this.#supportText = "Senha é obrigatório";
      return this;
    }

    this.#validity = validity.VALID;
    this.#supportText = "";
    return this;
  }

  [__.isEmpty__]() {
    return this.#value;
  }
}

export default Password;
